/**
 * A document's journal as stored in `sources_health.metadata.journal`. Either part is omitted
 * when the source did not carry it. Mirrors tangrowth's `Journal`.
 */
export interface StoredJournal {
  title?: string;
  /** The journal's NLM Catalog id, which unlike its title is spelled one way. */
  nlm_id?: string;
}

/** Builds the stored journal from a title and an id; null when there is neither. */
export function buildStoredJournal(
  title: string | null | undefined,
  nlmId: string | null | undefined
): StoredJournal | null {
  const journal: StoredJournal = {
    ...(title ? { title } : {}),
    ...(nlmId ? { nlm_id: nlmId } : {}),
  };
  return Object.keys(journal).length > 0 ? journal : null;
}

/** The journal title in a document's metadata; null when it has none. */
export function readJournalTitle(
  metadata: Record<string, unknown> | null | undefined
): string | null {
  const journal = metadata?.journal;
  if (typeof journal !== "object" || journal === null) return null;
  const { title } = journal as StoredJournal;
  return typeof title === "string" && title.trim() ? title : null;
}
